import api from "api";
import { useQuery } from "react-query";
import { queryKeys } from "utils/misc";

interface GetLessonsParams {
  locale?: string;
  search?: string;
  page?: number;
  limit?: number;
}

export const useGetLessons = (params: GetLessonsParams = {}) => {
  const { search, locale = "sv-SE", page = 0, limit = 25 } = params;

  const queryParams = new URLSearchParams();
  if (locale) {
    queryParams.set("locale", locale);
  }
  if (page !== undefined) {
    queryParams.set("page", (page + 1).toString());
  }
  if (limit !== undefined) {
    queryParams.set("limit", limit.toString());
  }
  if (search?.trim()) {
    queryParams.set("search", search.trim());
  }

  return useQuery(queryKeys.getLessons(params), () =>
    // @ts-ignore
    api.parse(`GET /lessons?${queryParams.toString()}`, {
      root: process.env.REACT_APP_API_URL_V2 + "/v2/support",
    })
  );
};
